import { Messages } from "../../db";
import { upsertConversationMeta } from "../../db/ConversationMetadata.js";
import useConversationStore from "../../stores/ConversationStore";
import { loadLocalKeys } from "../../db/KeyStorageManager";
import { storeHandshakeRequest } from "../../db/HandshakeRequests";
import { getSDK as getUnlinkSDK } from "../../sdk/UnlinkInstance";
import { createMessageObject } from "../../types/Message";
import bs58 from "bs58";
import { FEES } from "../../Config";

/**
 * Handle and route a parsed chat message.
 * @param {Object} message
 * @param {string} message.messageId
 * @param {string} message.conversationId
 * @param {Object} message.parsed
 * @param {number} message.timestamp
 * @param {string} message.viewKey - public view key
 * @param {string} message.alias
 * @param {string} message.password - user's password (must be provided to decrypt later)
 */
export default async function dispatchParsedHandshakeRequest({
  message, 
  receiverIdentityViewPublicKey, 
  localIsSender, 
  userId, 
  password, 
  salt,
}) {

  console.log("[dispatchToChat] Handshake request:", message);

  const unlinkSdk = getUnlinkSDK();
  const { 
    messageType, 
    parsed, 
    senderViewPublicKey,
  } = message;

  // mininum required spam fee
  if (localIsSender || message.totalFeeLamports >= FEES.SPAM_MITIGATION_LAMPORTS) {

    const timestamp = Date.now();

    // handshake request is 1:1 and conversation id should always be the determintic conversation id
    const conversationId = await unlinkSdk.generateDeterministicConversationId({
      viewKeyA: senderViewPublicKey,
      viewKeyB: receiverIdentityViewPublicKey,
    });

    // create message object
    const messageJSON = JSON.stringify(createMessageObject({
      message: {
        kyberPublicKey: bs58.encode(parsed.kyberPublicKey),
        message: parsed.message,
        version: parsed.version,
      },
      messageId: message.messageId,
      messageType,
      receiverViewPublicKey: bs58.encode(receiverIdentityViewPublicKey),
      senderViewPublicKey: bs58.encode(senderViewPublicKey),
      totalFeeLamports: message.totalFeeLamports,
      timestamp,
    }));

    console.log('dispatchParsedHandshakeRequest createMessageObject', JSON.parse(messageJSON));

    // Save the full message encrypted
    await Messages.storeEncryptedMessage({
      conversationId,
      messageJSON,
      timestamp,
      userId,
      password,
    });

    // Upsert into metadata table (conversation store)
    await upsertConversationMeta({
      conversationId,
      conversationName: null,
      lastMessage: messageJSON,
      participants: [senderViewPublicKey, receiverIdentityViewPublicKey],
      senderViewPublicKey: senderViewPublicKey,
      userId,
      password,
    });
  }
}